//Constants file for ReusableComponents

//Constants for Project.jsx
export const CONTRIBUTIONS = "Contributions:";
export const TOOLS = "Outils:";
export const LEARN_MORE = "En savoir plus sur mon expérience !";
